import { render } from "./ClientInventarioMarcas.vue?vue&type=template&id=a690f47c&scoped=true"
import script from "./ClientInventarioMarcas.vue?vue&type=script&lang=js"
export * from "./ClientInventarioMarcas.vue?vue&type=script&lang=js"

import "./ClientInventarioMarcas.vue?vue&type=style&index=0&id=a690f47c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a690f47c"]])

export default __exports__